import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import Video from './Video';
import convert from 'xml-js';
import { replaceSpecialChars, parseJson } from 'utils/JsonUtils.js';

class LiveStreamVideo extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    autoPlay: PropTypes.bool
  } 

  shouldComponentUpdate(nextProps) {
    return nextProps.FRN_rawResponses && nextProps.FRN_rawResponses.length > 0 ? true : false;
  }

  _cleanXmlObj(widget) {
    return {
      ...widget,
      id: widget.id._text,
      json: widget.json._text
    };
  }

  render() {
    if (!this.props.FRN_rawResponses || this.props.FRN_rawResponses.length === 0) {
      return null;
    }

    let dataStr = this.props.FRN_rawResponses[0].data;
    try {
      if (dataStr && typeof dataStr === 'string') {
        this.props.FRN_rawResponses[0].data = convert.xml2js(dataStr, {compact: true});
        this.props.FRN_rawResponses[0].data.widgets.widgets = this._cleanXmlObj(this.props.FRN_rawResponses[0].data.widgets.widgets);
      }
    } catch (error) {
      console.log(error);
    }

    const {
      FRN_rawResponses: [
        {
          data: {
            widgets: {
              widgets: {
                id: widgetId,
                json: jsonString = ''
              } = {}
            } = {}
          } = {}
        }
      ] = [],
      autoPlay = true
    } = this.props;

    // only remove some special characters such as tab, new line, new carrier....
    const stringWithoutSpecialChars = replaceSpecialChars(jsonString, '', jsonString);
    const widgetInformations = parseJson(stringWithoutSpecialChars, []);
    const widgetInformation = _.find(widgetInformations, {Type: 'VideoCanvas'}) || {};
    const {
      streamingUrl: strUrl = '',
      streamHeadline: strHeadline = '',
      streamHasPreroll: hasPreroll = '',
      liveStreamGraphicUrl: strSummaryImageUrl = '',
      contentClassification: strAdTag = '',
      mobileStreamCcUrl = '',
      mobileStream1 = '',
      mobileStream2 = '',
      mobileStream3 = '',
    } = widgetInformation;

    const liveStreamInfo = {
      strUrl,
      strHeadline,
      strSummaryImageUrl,
      mobileStreamCcUrl,
      hasPreroll: hasPreroll === 'yes',
      strAdTag,
      mobileStreams: [{
        url: mobileStream1,
        type: 'video/mp4'
      }, {
        url: mobileStream2,
        type: 'video/mp4'
      }, {
        url: mobileStream3,
        type: 'video/mp4'
      }]
    };

    /**
     * Add to Video
     * wNVideoCanvas.SetFlashLiveStream(liveStreamInfo);
     */
    const wNVideoCanvasProps = [{
       SetFlashLiveStream: [liveStreamInfo]
    }];

    return (
      <Video clipId={widgetId} autoPlay={autoPlay} wNVideoCanvasProps={wNVideoCanvasProps}/>
    );
  }

}
export default LiveStreamVideo;



// WEBPACK FOOTER //
// ./app/components/media/LiveStreamVideo.js